import { render } from "./FeedbackInfo.vue?vue&type=template&id=33bb85a8&scoped=true&lang=pug"
import script from "./FeedbackInfo.vue?vue&type=script&lang=js"
export * from "./FeedbackInfo.vue?vue&type=script&lang=js"

import "./FeedbackInfo.vue?vue&type=style&index=0&id=33bb85a8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33bb85a8"]])

export default __exports__